import { render, staticRenderFns } from "./WorkoutPlan.vue?vue&type=template&id=02212af8"
import script from "./WorkoutPlan.vue?vue&type=script&lang=js"
export * from "./WorkoutPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports